module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_600.fa7fa2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media-articles/fullscreen-image_hero_600.png
// module id = 7p2/
// module chunks = 0